<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/quality/inspection/setting/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jianyanleixing')">
            <el-select v-model="yt.conditions.inspectionType" clearable>
              <el-option :label="$t('shoujian')" :value="1"></el-option>
              <el-option :label="$t('choujian')" :value="2"></el-option>
              <el-option :label="$t('mojian')" :value="3"></el-option>
              <el-option :label="$t('chengpinjian')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_quality_management_inspection_setting_create')" size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1'); setDefaultValue(); getProcedureCode(); getInspectionList()" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->
      <template #jianyanleixing="scope">
        <span v-if="scope.row.inspectionType === 1">{{ $t('shoujian') }}</span>
        <span v-if="scope.row.inspectionType === 2">{{ $t('choujian') }}</span>
        <span v-if="scope.row.inspectionType === 3">{{ $t('mojian') }}</span>
        <span v-if="scope.row.inspectionType === 4">{{ $t('chengpinjian') }}</span>
      </template>
      <template #chufaleixing="scope">
        <span v-if="scope.row.triggerType === 1">{{ $t('shoujianjianyan') }}</span>
        <span v-if="scope.row.triggerType === 2">{{ $t('mojianjianyan') }}</span>
        <span v-if="scope.row.triggerType === 3">{{ $t('shijianjiange') }}</span>
        <span v-if="scope.row.triggerType === 4">{{ $t('shengchanshuliang') }}</span>
        <span v-if="scope.row.triggerType === 5">{{ $t('gongdanbaogong') }}</span>
      </template>
      <template #shifouqiyong="scope">
        <span v-if="scope.row.enabled === false">{{ $t('fou') }}</span>
        <span v-if="scope.row.enabled === true">{{ $t('shi') }}</span>
      </template>
      <template #gongxubianmamiaoshu="scope">
        <span v-if="!(scope.row.basicWorkProcedure == null)">{{ scope.row.basicWorkProcedure.code }}/{{
      scope.row.basicWorkProcedure.desc }}</span>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_quality_management_inspection_setting_update')" @click="yt.showEditDialog('bianji', scope.row, 'w1'); getProcedureCode(); getInspectionList()">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_quality_management_inspection_setting_delete')" class="font-color-danger" @click="yt.remove(scope.row, '/web/quality/inspection/setting/delete')">{{
      $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('jianyanleixing')" required>
            <el-select v-model="yt.editObj.inspectionType" @change="inspectionTypeChange(); yt.editObj.triggerType = ''; yt.editObj.triggerValue = '';" clearable>
              <el-option :label="$t('shoujian')" :value="1"></el-option>
              <el-option :label="$t('choujian')" :value="2"></el-option>
              <el-option :label="$t('mojian')" :value="3"></el-option>
              <el-option :label="$t('chengpinjian')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jianyanfangshi')" required>
            <el-select :max="1" filterable :clearable="true" v-model="yt.editObj.inspectionMethodId" @change="$forceUpdate()">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!--工序编码-->
          <el-form-item :label="$t('gongxubianma/miaoshu')" required>
            <el-select @change="$forceUpdate()" filterable :clearable="true" v-model="yt.editObj.basicWorkProcedureId">
              <el-option v-for="(item, index) in codeAndDesc" :key="index" :label="item.codeAndDesc" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="yt.editObj.inspectionType !== ''" :label="$t('chufaleixing')" required>
            <el-select v-model="yt.editObj.triggerType" @change="$forceUpdate();" clearable>
              <!--              自动触发类型，1首件检验，2时间间隔，3生产数量，4末件检验，5工单报,6首次机器记录数 7工单开始 -->
              <template v-if="yt.editObj.inspectionType == 1">
                <el-option :label="$t('shoucibaogong')" :value="1"></el-option>
                <el-option :label="$t('shoucijiqijilushu')" :value="6"></el-option>
                <el-option :label="$t('gongdankaishi')" :value="7"></el-option>
                <el-option :label="$t('zhidingshijian')" :value="8"></el-option>
              </template>
              <template v-else-if="yt.editObj.inspectionType == 2">
                <el-option :label="$t('shijianjiange')" :value="2"></el-option>
                <el-option :label="$t('shengchanshuliang')" :value="3"></el-option>
                <el-option :label="$t('zhidingshijian')" :value="8"></el-option>
              </template>
              <template v-else-if="yt.editObj.inspectionType == 3">
                <el-option :label="$t('mojianjianyan')" :value="4"></el-option>
                <el-option :label="$t('zhidingshijian')" :value="8"></el-option>
              </template>
              <template v-else-if="yt.editObj.inspectionType == 4">
                <el-option :label="$t('gongdanbaogong')" :value="5"></el-option>
                <el-option :label="$t('zhidingshijian')" :value="8"></el-option>
              </template>
              <template v-else>
                <el-option :label="$t('shoujianjianyan')" :value="1"></el-option>
                <el-option :label="$t('mojianjianyan')" :value="4"></el-option>
                <el-option :label="$t('shijianjiange')" :value="2"></el-option>
                <el-option :label="$t('shengchanshuliang')" :value="3"></el-option>
                <el-option :label="$t('gongdanbaogong')" :value="5"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item v-show="yt.editObj.triggerType == 8" :label="$t('jianyanshijian')" required>
            <el-input style="width: 30px;" v-model="yt.editObj.inspectionTimes" :disabled="true"></el-input>
            <!-- <el-button style="margin-left: -30px;" type="text" size="mini"
              @click="yt.showEditDialog('xuanzejianyanshijian', null, 'w1')">{{ $t('xuanze') }}</el-button> -->
            <!-- 选择按钮 -->
            <el-button style="margin-left: -10px;" type="text" size="mini" @click="openTimePickerDialog">
              {{ $t('xuanze') }}
            </el-button>
          </el-form-item>
          <template v-if="yt.editObj.inspectionType == 2">
            <el-form-item :label="$t('shezhizhi(fenzhong/shuliang)')" required>
              <el-input v-model="yt.editObj.triggerValue" oninput="value=value.replace(/^(0+)|[^\d]+/g, '')" @input="$forceUpdate()"></el-input>
            </el-form-item>
          </template>
          <template v-if="yt.editObj.inspectionType == 1 || yt.editObj.inspectionType == 3 || yt.editObj.inspectionType == 4">
            <el-form-item :label="$t('shezhizhi(fenzhong/shuliang)')">
              <el-input disabled v-model="yt.editObj.triggerValue" oninput="value=value.replace(/^(0+)|[^\d]+/g, '')" @input="$forceUpdate()"></el-input>
            </el-form-item>
          </template>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enabled" @change="$forceUpdate()">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '检验设置-新增检验设置' } }" @click="yt.req('POST', '/web/quality/inspection/setting/create', beforeNewAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('jianyanleixing')" required>
            <el-select v-model="yt.editObj.inspectionType" @change="inspectionTypeChange(); yt.editObj.triggerType = ''; yt.editObj.triggerValue = '';" clearable>
              <el-option :label="$t('shoujian')" :value="1"></el-option>
              <el-option :label="$t('choujian')" :value="2"></el-option>
              <el-option :label="$t('mojian')" :value="3"></el-option>
              <el-option :label="$t('chengpinjian')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jianyanfangshi')" required>
            <el-select :max="1" filterable :clearable="true" v-model="yt.editObj.inspectionMethodId">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!--工序编码-->
          <el-form-item :label="$t('gongxubianma/miaoshu')" required>
            <el-select @change="$forceUpdate()" filterable :clearable="true" v-model="yt.editObj.basicWorkProcedureId">
              <el-option v-for="(item, index) in codeAndDesc" :key="index" :label="item.codeAndDesc" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="yt.editObj.inspectionType !== ''" :label="$t('chufaleixing')" required>
            <el-select v-model="yt.editObj.triggerType" @change="$forceUpdate();" clearable>
              <!--              自动触发类型，1首件检验，2时间间隔，3生产数量，4末件检验，5工单报-->
              <template v-if="yt.editObj.inspectionType == 1">
                <el-option :label="$t('shoucibaogong')" :value="1"></el-option>
                <el-option :label="$t('shoucijiqijilushu')" :value="6"></el-option>
                <el-option :label="$t('gongdankaishi')" :value="7"></el-option>
                <el-option :label="$t('zhidingshijian')" :value="8"></el-option>
              </template>
              <template v-else-if="yt.editObj.inspectionType == 2">
                <el-option :label="$t('shijianjiange')" :value="2"></el-option>
                <el-option :label="$t('shengchanshuliang')" :value="3"></el-option>
                <el-option :label="$t('zhidingshijian')" :value="8"></el-option>
              </template>
              <template v-else-if="yt.editObj.inspectionType == 3">
                <el-option :label="$t('mojianjianyan')" :value="4"></el-option>
                <el-option :label="$t('zhidingshijian')" :value="8"></el-option>
              </template>
              <template v-else-if="yt.editObj.inspectionType == 4">
                <el-option :label="$t('gongdanbaogong')" :value="5"></el-option>
                <el-option :label="$t('zhidingshijian')" :value="8"></el-option>
              </template>
              <template v-else>
                <el-option :label="$t('shoujianjianyan')" :value="1"></el-option>
                <el-option :label="$t('mojianjianyan')" :value="4"></el-option>
                <el-option :label="$t('shijianjiange')" :value="2"></el-option>
                <el-option :label="$t('shengchanshuliang')" :value="3"></el-option>
                <el-option :label="$t('gongdanbaogong')" :value="5"></el-option>
                <el-option :label="$t('zhidingshijian')" :value="8"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item v-show="yt.editObj.triggerType == 8" :label="$t('jianyanshijian')" required>
            <el-input style="width: 30px;" v-model="yt.editObj.inspectionTimes" :disabled="true"></el-input>
            <!-- <el-button style="margin-left: -30px;" type="text" size="mini"
              @click="yt.showEditDialog('xuanzejianyanshijian', null, 'w1')">{{ $t('xuanze') }}</el-button> -->
            <!-- 选择按钮 -->
            <el-button style="margin-left: -10px;" type="text" size="mini" @click="openTimePickerDialog">
              {{ $t('xuanze') }}
            </el-button>
          </el-form-item>
          <template v-if="yt.editObj.inspectionType == 2">
            <el-form-item :label="$t('shezhizhi(fenzhong/shuliang)')" required>
              <el-input v-model="yt.editObj.triggerValue" oninput="value=value.replace(/^(0+)|[^\d]+/g, '')" @input="$forceUpdate()"></el-input>
            </el-form-item>
          </template>
          <template v-if="yt.editObj.inspectionType == 1 || yt.editObj.inspectionType == 3 || yt.editObj.inspectionType == 4">
            <el-form-item :label="$t('shezhizhi(fenzhong/shuliang)')">
              <el-input disabled v-model="yt.editObj.triggerValue" oninput="value=value.replace(/^(0+)|[^\d]+/g, '')" @input="$forceUpdate()"></el-input>
            </el-form-item>
          </template>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enabled" @change="$forceUpdate()">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/quality/inspection/setting/update', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>


    </el-dialog>
    <template>
      <div style="display: inline; ">
        <el-dialog :title="$t('zhidingshijian')" :visible.sync="checkTimesSelectWindows" width="30%">
          <div style="flex:1;" class="dialog-scroller">
            <yi_curd_table v-if="yt.isShowEditDialog" :name="$options.name + '2'" ref="yt2" :columns="columnsItem">
              <!-- 左侧按钮插槽 -->
              <template #buttonsL>
                <el-button size="mini" @click="addRow" type="primary">
                  {{ $t('xinzeng') }}
                </el-button>
              </template>


              <template #shijian="scope">
                <div>
                  <el-time-picker v-model="scope.row.inspectionTimes" value-format="HH:mm" :clearable="false" :editable="false" :format="'HH:mm'" :size="'mini'">
                  </el-time-picker>
                </div>
              </template>

              <template #caozuo="scope">
                <el-row :gutter="10">
                  <el-col :span="0.1">
                    <el-button type="text" class="font-color-danger" @click="deleteRow(scope._index)">
                      {{ $t('shanchu') }}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </yi_curd_table>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancelAndClose">{{ $t('quxiao') }}</el-button>
            <el-button type="primary" @click="saveTimes">{{ $t('baocun')}}</el-button>
          </span>
        </el-dialog>
      </div>
    </template>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_quality_management_inspection_setting_list',
  data() {
    return {

      checkTimesSelectWindows: false,
      timePickers: [''], // 存储时间选择器的数组，初始时包含一个空值
      inspectionTimes: '',
      typeList: [],
      codeAndDesc: '',
      columns: [{
        label: 'jianyanleixing',
        type: 'slot',
        width: 150
      },
      {
        label: 'jianyanfangshi',
        prop: 'inspectionMethod.name',
        width: 180,
      },
      {
        label: 'gongxubianmamiaoshu',
        type: 'slot',
        width: 150
      },
      {
        label: 'chufaleixing',
        prop: 'triggerType',
        type: 'dictionary',
        key: 'QUALITY_INSPECTION_TRIGGER_TYPE',
        width: 150
      },
      {
        label: 'shezhizhi(fenzhong/shuliang)',
        prop: 'triggerValue',
        width: 180,
      }, {
        label: 'shifouqiyong',
        prop: 'enabled',
        type: 'slot',
      }, {
        label: 'chuangjianren',
        prop: 'createByObject.nickname',
        width: 150,
      }, {
        label: 'chuangjianshijian',
        prop: 'createTime',
        type: 'time',
        width: 150,
      }, {
        label: 'caozuo',
        type: 'slot',
        width: 150,
        fixed: 'right'
      }],
      columnsItem: [
        {
          label: 'paixu',
          type: 'index'
        },
        {
          label: 'shijian',
          type: 'slot',
          width: 300
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ],
    };
  },
  created() {
    setTimeout(() => {
      console.log(this.yt.get(1))
      this.yt.get(1);

    }, 300)

  },
  mounted() {
    // 确保yt2已经可用

  },
  methods: {
    cancelAndClose() {
      this.checkTimesSelectWindows = false; // 关闭窗口
    },

    deleteRow(index, rows) {
      this.$refs.yt2.list.splice(index, 1);
    },
    move(index, type) {
      console.log('选中', index);
      if (type == 1) {
        /* //上移
          let index = 0;
          for (let i = 0; i < this.$refs.yt2.list.length; i++) {
            if (this.$refs.yt2.list[i].checked == true) {
              index = i
              break
            }
          } */
        console.log('索引', index);
        if (index > 0) {
          let tempsArr = this.utils.copy(this.$refs.yt2.list);
          let temp = tempsArr[index - 1];
          // temp.checked = true
          tempsArr[index - 1] = tempsArr[index];
          tempsArr[index] = temp;
          this.$refs.yt2.list = tempsArr;
          console.log('交换位置后', this.$refs.yt2.list);
          this.setCurrent(this.$refs.yt2.list[index - 1]);
        }
      }
      if (type == 2) {
        /* //下移 
          let index = 0;
          for (let i = 0; i < this.$refs.yt2.list.length; i++) {
            if (this.$refs.yt2.list[i].checked == true) {
              index = i
              break
            }
          } */
        console.log('索引', index);
        if (index < this.$refs.yt2.list.length - 1) {
          let tempsArr = this.utils.copy(this.$refs.yt2.list);
          let temp = tempsArr[index + 1];
          tempsArr[index + 1] = tempsArr[index];
          tempsArr[index] = temp;
          this.$refs.yt2.list = tempsArr;
          console.log('交换位置后', this.$refs.yt2.list);
          this.setCurrent(this.$refs.yt2.list[index + 1]);
        }
      }
    },
    /* setCurrent(row) {
        this.$refs.singleTable.setCurrentRow(row);
      }, */
    addRow(rows) {
      console.log('增加一行', rows);
      this.$refs.yt2.list.push({
        inspectionTimes: ''
      });
    },
    openTimePickerDialog() {
      this.checkTimesSelectWindows = true;
      // 检查list是否为空，如果为空，则自动添加一个空行
      this.$nextTick(() => {
        if (this.$refs.yt2.list.length === 0 && this.yt.editObj.inspectionTimes == null) {
          this.$refs.yt2.list.push({ inspectionTimes: '' })
        }
        if (this.yt.editObj.inspectionTimes) {
          const inspectionTimesArray = this.yt.editObj.inspectionTimes.split(',');
          console.log('inspectionTimes', this.yt.editObj.inspectionTimes)
          console.log('inspectionTimesArray', inspectionTimesArray)
          for (let index = 0; index < inspectionTimesArray.length; index++) {
            const element = inspectionTimesArray[index];
            console.log("element", element)
            if (this.$refs.yt2.list.length < inspectionTimesArray.length) {
              this.$refs.yt2.list.push({ inspectionTimes: element })
              console.log("list", this.$refs.yt2.list)
            }

          }

        }


      })
    },


    addTimePicker() {
      // 增加一个新的时间选择器
      this.timePickers.push('');
    },
    removeTimePicker(index) {
      // 移除指定索引的时间选择器
      if (this.timePickers.length > 1) {
        this.timePickers.splice(index, 1);
      }
    },
    // saveTimes() {
    //   console.log("保存",this.$refs.yt2.list)
    //   if (this.$refs.yt2.list.some((time, index) => this.$refs.yt2.list.indexOf(time) !== index)) {
    //     this.utils.errorMessage(this.$t('cunzaichongfushijian'));
    //     return;
    //   }
    //   this.yt.editObj.inspectionTimes = this.$refs.yt2.list.map(item => {
    //     return (item.inspectionTimes) ? item.inspectionTimes : '';
    //   }).join(',');

    //   // 清空yt2.list数据
    //   // this.$refs.yt2.list = [];
    //   this.checkTimesSelectWindows = false; // 关闭窗口
    // }
    saveTimes() {
      const timesSet = new Set();
      const hasDuplicate = this.$refs.yt2.list.some(item => {
        if (timesSet.has(item.inspectionTimes)) {
          return true; // 找到重复的值
        }
        timesSet.add(item.inspectionTimes);
        return false;
      });

      if (hasDuplicate) {
        this.utils.errorMessage(this.$t('cunzaichongfushijian'));
        return;
      }

      this.yt.editObj.inspectionTimes = this.$refs.yt2.list.map(item => {
        return item.inspectionTimes ? item.inspectionTimes : '';
      }).join(',');

      // 清空yt2.list数据
      // this.$refs.yt2.list = [];
      this.checkTimesSelectWindows = false; // 关闭窗口
    },

    checkTimesSelect() {
      this.checkTimesSelectWindows = true;
      console.log('this.checkTimesSelectWindows', this.checkTimesSelectWindows)
    },
    async getInspectionList() {
      return await this.http.get('/web/quality/inspection/method/page?' + this.qs.stringify({
        pageNum: 1,
        pageSize: 100,
        inspectionType: this.yt.editObj.inspectionType
        // orderBy: 'sort',
      })).then(response => {
        this.typeList = response.data.rows || []
      }).catch(() => {

      })
    },
    inspectionTypeChange(value) {
      this.getInspectionList()
      setTimeout(() => {
        this.yt.editObj.inspectionMethodId = ''
      }, 100)
      console.log('inspectionTypeChange', value)
      this.$forceUpdate()
    },
    getProcedureCode() {
      this.http.get('/web/craft/basic/work/procedure/list').then(res => {
        this.codeAndDesc = res.data
        if (this.yt.editObj.action == 'xinzeng') {
          this.yt.editObj.basicWorkProcedureId = this.codeAndDesc[0].id
        }
      })
    },
    setDefaultValue() {
      this.yt.editObj.inspectionType = 1
      // this.yt.editObj.enabled = 1
      this.yt.editObj.enabled = true
    }
  },
};
</script>
